import { configureStore } from "@reduxjs/toolkit";
import roleReducer from "./reducers/roleSlice";
import imageReducer from "./reducers/imageSlice";
import userReducer from "./reducers/localSlice";
import routeReducer from "./reducers/routeSlice";
import testReducer from "services/Crm/reducers/testSlice";
import recruitmentReducer from 'common/redux/reducers/recruitmentSlice'
import departmentReducer from 'common/redux/reducers/departmentSlice'
import usersReducer from 'common/redux/reducers/userSlice'
import attachmentsReducer from 'common/redux/reducers/attachmentSlice'
import contactLeadReducer from 'common/redux/reducers/contactLeadSlice'
import dynamicModuleReducer from "./reducers/dynamicModuleSlice";
import userViewSliceReducer from "./reducers/userViewSlice";

const store = configureStore({
  reducer: {
    roles: roleReducer,
    images: imageReducer,
    user: userReducer,
    route: routeReducer,
    test: testReducer,
    recruitment: recruitmentReducer,
    departments: departmentReducer,
    users: usersReducer,
    attachments: attachmentsReducer,
    contactLead: contactLeadReducer,
    dynamicModule: dynamicModuleReducer,
    userView: userViewSliceReducer,
  },
});

export default store;
